exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".rc-slider-vertical{\r\n    height: 230px;\r\n    width: 20px;\r\n    margin-right: 20px;\r\n    display: inline-block;\r\n}\r\n\r\n.rc-slider-vertical {\r\n    \r\n}\r\n", "", {"version":3,"sources":["C:/Users/andco/Desktop/al/src/components/content/Inputs/Slider.css"],"names":[],"mappings":"AAAA;IACI,cAAa;IACb,YAAW;IACX,mBAAkB;IAClB,sBAAqB;CACzB;;AAEA;;CAEA","file":"Slider.css","sourcesContent":[".rc-slider-vertical{\r\n    height: 230px;\r\n    width: 20px;\r\n    margin-right: 20px;\r\n    display: inline-block;\r\n}\r\n\r\n.rc-slider-vertical {\r\n    \r\n}\r\n"],"sourceRoot":""}]);

// exports
